import React from 'react';
import { ShippingStatusContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { portalService } from 'apiServices';
import { toast } from 'react-toastify';
import { Displays, Forms } from 'components';
import { CURRENT_SHIPPING_STATUS } from 'utils/functions/shipping';

class ShippingStatusContainer extends React.Component {
  state = {};

  handleSubmit = async (values) => {
    const { data, onSuccess } = this.props;
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    this.setState({ isLoadingBg: true });

    let res = await portalService.PUT_REWARD_HISTORY_SHIPPING_STATUS(data._id, {
      shipping_status: values.shipping_status,
      reason: values.reason || '',
      // ส่งสถานะที่โมดัลเห็นตอนเปิดไปด้วย กันเคสเปิดค้างไว้แล้วมีคนอื่นแก้แซง
      from_status: CURRENT_SHIPPING_STATUS(data.shipping_status),
    });

    this.isSubmitting = false;
    this.setState({ isLoadingBg: false });

    if (res && res.status === 200) {
      toast.success(
        res.data && res.data.changed === false
          ? 'ไม่มีการเปลี่ยนแปลง'
          : 'อัปเดตสถานะสำเร็จ'
      );
      onSuccess && onSuccess();
    } else {
      // axiosError คืน error.response ตัวเต็ม ตัว body อยู่ที่ res.data
      const message =
        (res && res.data && res.data.error && res.data.error.message) ||
        'อัปเดตไม่สำเร็จ';
      toast.error(message);
    }
  };

  render() {
    const { data, onCancel } = this.props;
    const { isLoadingBg } = this.state;
    return (
      <ShippingStatusContainerStyled>
        <Displays.BGLoading visible={isLoadingBg} />
        <div className="modal_title">อัปเดตสถานะการจัดส่ง</div>
        <Forms.ShippingStatusForm
          data={data}
          onSubmit={this.handleSubmit}
          onCancel={onCancel}
          disabled={isLoadingBg}
        />
      </ShippingStatusContainerStyled>
    );
  }
}

export default withRouter(ShippingStatusContainer);
